import { handleScrollNavigation } from "Helper";
import "./Indications.scss";

const relaxante = "relaxante";
const bioenergetica = "bioenergetica";
const linfatica = "linfatica";
const miofascial = "miofascial";
const reiki = "reiki";
const coneterapia = "coneterapia";
const meditacaoGuiada = "meditacao-guiada";

const data = [
  { 
    complaint: "Estresse e tensão muscular", 
    techniques: [
      { name: "Massagem Relaxante", sectionLink: relaxante },
      { name: "Liberação Miofascial", sectionLink: miofascial }
    ] 
  },
  { 
    complaint: "Cansaço excessivo / fadiga física", 
    techniques: [
      { name: "Drenagem Linfática", sectionLink: linfatica },
      { name: "Liberação Miofascial", sectionLink: miofascial }
    ] 
  },
  { 
    complaint: "Ansiedade e agitação mental", 
    techniques: [
      // { name: "Meditação Guiada", sectionLink: meditacaoGuiada },
      { name: "Reiki", sectionLink: reiki },
      { name: "Massagem Bioenergética", sectionLink: bioenergetica }
    ] 
  },
  { 
    complaint: "Dificuldade de concentração", 
    techniques: [
      // { name: "Meditação Guiada", sectionLink: meditacaoGuiada },
      { name: "Coneterapia", sectionLink: coneterapia },
      { name: "Reiki", sectionLink: reiki }
    ] 
  },
  { 
    complaint: "Irritabilidade e falta de paciência", 
    techniques: [
      { name: "Massagem Bioenergética", sectionLink: bioenergetica },
      // { name: "Meditação Guiada", sectionLink: meditacaoGuiada }
    ] 
  },
  { 
    complaint: "Sensação de “mente cheia” ou sobrecarga", 
    techniques: [
      { name: "Coneterapia", sectionLink: coneterapia },
      { name: "Reiki", sectionLink: reiki },
      // { name: "Meditação Guiada", sectionLink: meditacaoGuiada }
    ] 
  },
  { 
    complaint: "Inchaços e retenção de líquidos", 
    techniques: [
      { name: "Drenagem Linfática", sectionLink: linfatica }
    ] 
  },
  { 
    complaint: "Dores crônicas e posturais", 
    techniques: [
      { name: "Liberação Miofascial", sectionLink: miofascial },
      { name: "Massagem Relaxante", sectionLink: relaxante }
    ] 
  },
  { 
    complaint: "Falta de motivação / apatia", 
    techniques: [
      { name: "Massagem Bioenergética", sectionLink: bioenergetica },
      { name: "Reiki", sectionLink: reiki }
    ] 
  },
  { 
    complaint: "Desequilíbrio emocional", 
    techniques: [
      { name: "Reiki", sectionLink: reiki },
      { name: "Massagem Bioenergética", sectionLink: bioenergetica },
      // { name: "Meditação Guiada", sectionLink: meditacaoGuiada }
    ] 
  }
];

const Indications = () => {
  return (
    <section className="indications-section" id="indications">
      <h2>Queixas e Técnicas Recomendadas</h2>
      <div className="indications-container" data-aos="fade-up">
        <table className="custom-table">
          <thead>
            <tr>
              <th>Queixa Comum</th>
              <th>Técnicas Indicadas</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td data-aos="fade-left">{item.complaint}</td>
                <td data-aos="fade-right">
                  {item.techniques.map((tecnica, idx) => (
                    <a 
                      key={idx} 
                      href={`#${tecnica.sectionLink}`} 
                      className="tag"
                    >
                      {tecnica.name}
                    </a>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default Indications;
